import type { PluginConfiguration } from '../malleableUiPluginType';
import { parseMauiDiagramLink, type RovoConversationContext } from '../pm-plugins/detect-maui-link';
import {
	executeMauiEmbedFinalize,
	getMauiDiagramPasteView,
	type MauiEmbedFinalizeMode,
	type MauiEmbedFinalizeWorkflowArgs,
} from '../pm-plugins/maui-diagram-paste-plugin';

export type FinalizeMauiEmbedFromIndicatorArgs = {
	contentId?: string;
	conversationContext?: RovoConversationContext;
	mode?: MauiEmbedFinalizeMode;
	originalUrl: string;
};

export type FinalizeMauiEmbedFromIndicator = (
	args: FinalizeMauiEmbedFromIndicatorArgs,
) => Promise<void>;

export function makeFinalizeMauiEmbedFromIndicator({
	config,
}: {
	config: PluginConfiguration | undefined;
}): FinalizeMauiEmbedFromIndicator {
	return async (args: FinalizeMauiEmbedFromIndicatorArgs) => {
		const diagramPaste = config?.diagramPaste;
		if (!diagramPaste) {
			return;
		}

		const { originalUrl, conversationContext, mode } = args;

		// Use the view that owns this embed URL.
		const view = getMauiDiagramPasteView(originalUrl);
		if (!view) {
			return;
		}
		let contentId = args.contentId;
		if (!contentId) {
			const parsed = parseMauiDiagramLink(originalUrl);
			contentId = parsed?.contentId;
		}
		if (!contentId) {
			return;
		}

		const workflowArgs: MauiEmbedFinalizeWorkflowArgs = {
			contentId,
			originalUrl,
			conversationContext,
			mode,
		};

		await executeMauiEmbedFinalize(view, diagramPaste, workflowArgs);
	};
}
